import { api } from "./gmao";

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

function decodeKey(value) {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const raw = atob((value + padding).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

async function registration() {
  const reg = await navigator.serviceWorker.register("/service-worker.js");
  await navigator.serviceWorker.ready;
  return reg;
}

export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/service-worker.js");
  return reg ? reg.pushManager.getSubscription() : null;
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Este navegador no admite notificaciones push.");
  const reg = await registration();
  if ((await Notification.requestPermission()) !== "granted") throw new Error("Permiso de notificaciones denegado.");
  const { publicKey, enabled } = (await api.get("/push/public-key")).data;
  if (!enabled) throw new Error("Las notificaciones push no están configuradas en el servidor.");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: decodeKey(publicKey) });
  const j = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: j.endpoint, keys: j.keys });
  return sub;
}

export async function disablePush() {
  const sub = await currentSubscription();
  if (!sub) return;
  await api.delete("/push/subscribe", { data: { endpoint: sub.endpoint } }).catch(() => {});
  await sub.unsubscribe();
}
